import { render, staticRenderFns } from "./ShopUserRanking.vue?vue&type=template&id=4404df5b&scoped=true"
import script from "./ShopUserRanking.vue?vue&type=script&lang=js"
export * from "./ShopUserRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404df5b",
  null
  
)

export default component.exports